export default __webpack_public_path__ + "static/media/moneyhash_wallet.5ce56709.svg";